import React from "react"
import {Placeholder} from "@vkontakte/vkui";
import {FiAlertTriangle} from "react-icons/fi";

export default function InsertAlert({imageSize, selectedSize, Image}) {
    return (
        <div className="insert_alert">

            <FiAlertTriangle size={45} color={"orange"}/>
            <span className={"font_montserrat"}
                  style={{fontWeight: "bold", width: "100%", textAlign: "center", userSelect: "none", color: "white"}}>
                    Низкое качество
                </span>

        </div>
    )
}
